import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ParametrizacaoService } from 'src/app/services/ParametrizacaoService/parametrizacao.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-tolerancia-parametrizacao',
  templateUrl: './tolerancia-parametrizacao.component.html',
  styleUrls: ['./tolerancia-parametrizacao.component.scss']
})
export class ToleranciaParametrizacaoComponent implements OnInit, OnDestroy {
  private subscription$ = new Subscription();
  private parametrizacaoService = inject(ParametrizacaoService);

  isLoading: boolean = false;
  private pkAtrs: number = 0;
  private pkAdia: number = 0;

  form = this.fb.group({
    QT_TOLE_ATRS: this.fb.control<number>(0, { nonNullable: true, validators: [Validators.required, Validators.min(0)] }),
    UNIDADE_ATRS: this.fb.control<'horas' | 'minutos'>('horas', { nonNullable: true }),
    QT_TOLE_ADIA: this.fb.control<number>(0, { nonNullable: true, validators: [Validators.required, Validators.min(0)] }),
    UNIDADE_ADIA: this.fb.control<'horas' | 'minutos'>('horas', { nonNullable: true }),
  });

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.carregarParametros();
  }

  carregarParametros(): void {
    this.isLoading = true;
    this.subscription$.add(
      this.parametrizacaoService.GetParametrizacaoByName('QT_HORA_TOLE_ATRS').subscribe({
        next: (res) => {
          this.pkAtrs = res.PK_PRMT;
          this.form.controls.QT_TOLE_ATRS.setValue(Number(res.VL_PRMT));
        }
      })
    );
    this.subscription$.add(
      this.parametrizacaoService.GetParametrizacaoByName('QT_HORA_TOLE_ADIA').subscribe({
        next: (res) => {
          this.pkAdia = res.PK_PRMT;
          this.form.controls.QT_TOLE_ADIA.setValue(Number(res.VL_PRMT));
          this.isLoading = false;
        },
        error: () => { this.isLoading = false; }
      })
    );
  }

  onUnidadeChange(campo: 'ATRS' | 'ADIA'): void {
    const valorCtrl = campo === 'ATRS' ? this.form.controls.QT_TOLE_ATRS : this.form.controls.QT_TOLE_ADIA;
    const unidadeCtrl = campo === 'ATRS' ? this.form.controls.UNIDADE_ATRS : this.form.controls.UNIDADE_ADIA;
    const valor = valorCtrl.value;

    if (unidadeCtrl.value === 'minutos') {
      valorCtrl.setValue(+(valor * 60).toFixed(0));
    } else {
      valorCtrl.setValue(+(valor / 60).toFixed(2));
    }
  }

  private toHoras(valor: number, unidade: 'horas' | 'minutos'): number {
    return unidade === 'minutos' ? +(valor / 60).toFixed(4) : valor;
  }

  salvar(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const { QT_TOLE_ATRS, UNIDADE_ATRS, QT_TOLE_ADIA, UNIDADE_ADIA } = this.form.getRawValue();
    const horasAtrs = this.toHoras(QT_TOLE_ATRS, UNIDADE_ATRS);
    const horasAdia = this.toHoras(QT_TOLE_ADIA, UNIDADE_ADIA);

    this.isLoading = true;
    this.subscription$.add(
      this.parametrizacaoService.UpdateParametrizacao({
        Parametrizacao: { PK_PRMT: this.pkAtrs, NM_PRMT: 'QT_HORA_TOLE_ATRS', VL_PRMT: String(horasAtrs) }
      }).subscribe({
        next: () => {
          this.parametrizacaoService.UpdateParametrizacao({
            Parametrizacao: { PK_PRMT: this.pkAdia, NM_PRMT: 'QT_HORA_TOLE_ADIA', VL_PRMT: String(horasAdia) }
          }).subscribe({
            next: () => {
              this.isLoading = false;
              Swal.fire('Sucesso!', 'Tolerâncias salvas com sucesso.', 'success');
            },
            error: () => { this.isLoading = false; }
          });
        },
        error: () => { this.isLoading = false; }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription$.unsubscribe();
  }
}
